import { AxiosResponse } from "axios";
import { get, post, put, routes } from "api";
import {
  IGetNotificationsForUser,
  INotification,
  TNotificationForCreate,
} from "models/notificationItem.models";
import { TPaginationRequestParams } from "models/pagination.models";

const notifications = {
  markNotificationRead(notificationId: string, data: INotification) {
    return put(routes.notifications.notifications(notificationId), {
      data,
    });
  },

  getNotificationsForUser(
    userId: string,
    params: TPaginationRequestParams,
  ): Promise<AxiosResponse<IGetNotificationsForUser>> {
    return get(routes.notifications.getNotificationsForUser(userId), {
      params,
    });
  },

  markAllNotificationsRead(userId: string) {
    return post(routes.notifications.markAllNotificationsRead(userId));
  },

  createNotification(userId: string, data: TNotificationForCreate) {
    return post(routes.notifications.createNotification(userId), { data });
  },
};

export default notifications;
